import { Content as StyledContent } from './Styles'
import ContentWithSubMenu from './ContentWithSubMenu'
import type { CSSProperties, ReactNode } from 'react'

interface ContentProps {
  fluid?: boolean
  children: ReactNode
  basic?: boolean
  noPadding?: boolean
  noMinHeight?: boolean
  allowOverflow?: boolean
  withSubMenu?: boolean
  style?: CSSProperties
}

const Content = ({
  fluid,
  basic,
  noPadding,
  noMinHeight,
  children,
  allowOverflow,
  withSubMenu,
  ...rest
}: ContentProps) => {
  if (withSubMenu) {
    return (
      <ContentWithSubMenu
        noPadding={noPadding}
        noMinHeight={noMinHeight}
        allowOverflow={allowOverflow}
        basic={basic}
        {...rest}>
        {children}
      </ContentWithSubMenu>
    )
  }
  return (
    <StyledContent
      noPadding={noPadding}
      noMinHeight={noMinHeight}
      allowOverflow={allowOverflow}
      fluid={fluid}
      basic={basic}
      {...rest}>
      {children}
    </StyledContent>
  )
}

export default Content
